<template>
  <v-btn text block @click="getReportUrl" :disabled="loading" :loading="loading" class="report-button" v-if="$vuetify.breakpoint.mdAndUp">
    <v-icon class="mr-4">
      fas fa-download
    </v-icon>
    <span class="color-new-link-blue--text">{{ $t('reportButton') }}</span>
  </v-btn>
  <span @click="getReportUrl" :disabled="loading" :loading="loading" v-else>
    {{ $t('reportButton') }}
  </span>
</template>

<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['debtNr'],
    data: function () {
      return {
        loading: false
      }
    },
    computed: {
      locale() {
        return this.$store.getters.longLocale
      }
    },
    methods: {
      getReportUrl () {
        this.$matomo && this.$matomo.trackEvent("Information", "Download Report", "Print Debt Information")
        this.loading = true
        apiResource({ method: 'get', url: '/api/orders/balancereport/' + this.locale + '/' + this.debtNr, responseType: 'arraybuffer' }).then((response) => {
          this.loading = false
          let blob = new Blob([response.data], { type: 'application/pdf' })
          // IE10+ : (has Blob, but not a[download] or URL)
          if (navigator.msSaveBlob) {
            return navigator.msSaveBlob(blob, this.$t('balanceReport') + '_' + this.debtNr + '.pdf')
          } else {
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = this.$t('balanceReport') + '_' + this.debtNr + '.pdf'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch((errorResponse) => {
          this.loading = false
          this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "reportButton": "Lataa velkatiedot (pdf)",
  "balanceReport": "Saldoraportti"
  },
  "se": {
  "reportButton": "Ladda ner skuldinformation (pdf)",
  "balanceReport": "Saldorapport"
  },
  "en": {
  "reportButton": "Download debt information (pdf)",
  "balanceReport": "Balancereport"
  }
  }
</i18n>
